import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { OrderService } from 'src/app/services/order/order.service';

@Component({
  selector: 'app-customer',
  templateUrl: './addcustomer.component.html',
  styleUrls: ['./addcustomer.component.scss']
})
export class AddcustomerComponent implements OnInit {

  customerForm: FormGroup;
  customerCode: string;
  customerName: string;
  customerType: string;
  address: string;
  city: string;
  country: string;
  area: string;
  contactPerson: string;
  phoneNo: Number;
  email: string;

  //activity log
  activityLog = [];
  activityCreatedLog = [];
  activityUpdatedLog = [];
  fleetAddedBy: string;
  fleetCreationDate: string;
  fleetUpdationDate: string;
  alltransporters = [];
  isDuplicateCustomerCode: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    public router: Router,
    private datePipe: DatePipe,
    public customerService: CustomerService,
    public orderservice: OrderService

  ) {

    this.customerForm = formBuilder.group({
      'customerCode': [null],
      'customerName': [null, [
        Validators.required,
      ]],
      'customerType': [null, [
        Validators.pattern('^[a-zA-Z0-9 ]*$')
      ]],
      'houseNumber': [null,[
        Validators.required,
      ]],
      'city': [null,
        [Validators.pattern("^[a-zA-Z_ ]+$")
        ]],
      'country': [null],
      'area': [null, [
        Validators.pattern("^[a-zA-Z0-9_ ]+$")
      ]],
      'contactPerson': [null, [
        Validators.pattern("^[a-zA-Z_ ]+$")
      ]],
      'phoneNo': [null, [
        Validators.minLength(10),
        Validators.maxLength(10),
        Validators.pattern('^[0-9]*$')
      ]],
      'email': [null, [
        Validators.email]
      ],
      'pincode': [null, [
        Validators.required,
        Validators.pattern('^[0-9]*$')
      ]]
    });

  }
  openSnackBar(message) {
    let extraClasses;
    this.snackBar.open(message, 'ok', {
      duration: 2000,
      panelClass: ['extraClasses']
    });
  }

  ngOnInit() {

    this.customerService.getAllCustomers().subscribe(allCustomers => {
      console.log("all",allCustomers);
      let allBU = []
      allCustomers.forEach(customer => {
        allBU.push(customer.bu);
      });
    });
    //this.getTransoprterforfleet();
  }

  addCustomer() {
    console.log("form value", this.customerForm.value);
    let address = {}
    address = {
      houseNumber : this.customerForm.value.houseNumber,
      area : this.customerForm.value.area,
      city: this.customerForm.value.city,
      pincode : this.customerForm.value.pincode,
      country: this.customerForm.value.country,
      zone: this.customerForm.value.zone
    }
    delete this.customerForm.value.houseNumber;
    delete this.customerForm.value.area;
    delete this.customerForm.value.city;
    delete this.customerForm.value.pincode;
    delete this.customerForm.value.country;
    delete this.customerForm.value.zone;

     this.customerForm.value.address = address;
    this.customerService.AddCustomer(this.customerForm.value).subscribe(customeradded => {
      this.openSnackBar("Customer: " + this.customerForm.value.customerName + " added successfully.");
      this.router.navigateByUrl("/managecustomers");
    },Error => {
      console.log(Error);
    });
  }

  checkForDuplicateCode(event){
    console.log("function called",event.srcElement.value);
    this.customerService.checkDuplicateCustomerCode(event.srcElement.value).subscribe(isAvailable=>{
      console.log(isAvailable);
      if(isAvailable){
          this.isDuplicateCustomerCode = true;
      }
      else
      this.isDuplicateCustomerCode = false;
    });
  }
  typingCustomerCode(){
    this.isDuplicateCustomerCode = false;
  }
}